// Zdarzenia do Google Analytics: dokąd ludzie docierają, w co klikają i czy wysyłają formularz.
// Gdy licznik jest wyłączony (puste pole w Ustawieniach motywu), wszystko poniżej cicho nic nie robi.

/**
 * Jedno wyjście na świat: wprost do GA4, a gdy strona idzie przez Tag Managera – do warstwy danych.
 * Nazwy zdarzeń i parametrów bez polskich znaków, bo GA4 ich nie przyjmuje.
 */
export function track(name, params = {}) {
    if (typeof window.gtag === "function") {
        window.gtag("event", name, params);
    } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({event: name, ...params});
    }
}

const text = (el, selector) => el?.querySelector(selector)?.textContent.trim() || "";

export function initAnalytics() {
    document.addEventListener("click", (event) => {
        const link = event.target.closest("a");
        if (!link) {
            return;
        }

        // Wybór pakietu na stronie dla hodowców – razem z ceną z karty.
        const plan = link.closest("[data-cc-plan]") || (link.dataset.ccPlan ? link : null);
        if (plan) {
            const card = link.closest(".cc-plan");
            track("wybor_pakietu", {
                pakiet: plan.dataset.ccPlan || text(card, ".cc-plan__name"),
                cena: text(card, ".cc-plan__amount")
            });
            return;
        }

        const href = link.getAttribute("href") || "";
        if (href.startsWith("tel:")) {
            track("klik_telefon", {numer: href.slice(4)});
        } else if (href.startsWith("mailto:")) {
            track("klik_email", {adres: href.slice(7)});
        } else if (href.includes("instagram.com")) {
            track("klik_instagram", {skad: document.title});
        }
    });

    initForms();
    initSections();
}

/** Formularz: osobno „zaczął wypełniać” i osobno „wysłał” – różnica między nimi to porzucenia. */
function initForms() {
    document.querySelectorAll("form[data-cc-contact]").forEach((form) => {
        const topic = () => form.querySelector("select[name='cc_topic']")?.value || "";
        let started = false;
        form.addEventListener("focusin", () => {
            if (!started) {
                started = true;
                track("formularz_start", {temat: topic()});
            }
        });
    });
}

/** Dotarcie do kluczowych sekcji – stąd wiadomo, ilu w ogóle dochodzi do cennika. */
function initSections() {
    const sections = [...document.querySelectorAll(".cc-section[id]")];
    if (!sections.length || !("IntersectionObserver" in window)) {
        return;
    }
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }
            observer.unobserve(entry.target);
            track("sekcja_widziana", {sekcja: entry.target.id});
        });
    }, {threshold: 0.35});
    sections.forEach((section) => observer.observe(section));
}
